import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { LinkStyles, Text } from '@miro-site/core';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export var ITEM_CONTENT_SIZES = {
  small: 'p1',
  large: 'p0',
  tiny: 'p2',
  medium: 'p1medium'
};
var ITEM_CONTENT_COLORS = {
  dark: 'primaryIndigo',
  grey: 'greyish',
  white: 'primaryWhite'
};
var WEIGHT = {
  medium: undefined,
  bold: 700
};

var Content = function Content(_ref) {
  var html = _ref.html,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'grey' : _ref$color,
      _ref$textProps = _ref.textProps,
      textProps = _ref$textProps === void 0 ? {} : _ref$textProps,
      colorTransparency = _ref.colorTransparency,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? 'medium' : _ref$weight;
  textProps.$styles = _objectSpread({
    fontWeight: WEIGHT[weight],
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  }, textProps.$styles || {});

  var props = _objectSpread(_objectSpread({}, textProps), {}, {
    $variant: ITEM_CONTENT_SIZES[size],
    $color: ITEM_CONTENT_COLORS[color],
    $transparency: colorTransparency
  });

  if (typeof html === 'string') {
    return /*#__PURE__*/_jsx(TextWithInlineHtml, _objectSpread({
      dangerouslySetInnerHTML: {
        __html: html
      }
    }, props));
  }

  return /*#__PURE__*/_jsx(TextWithInlineHtml, _objectSpread(_objectSpread({}, props), {}, {
    children: html
  }));
};

var TextWithInlineHtml = styled(Text).withConfig({
  displayName: "Content__TextWithInlineHtml",
  componentId: "sc-133qkbj-0"
})(["a{", "}"], function (props) {
  return props.theme.normalizeStyles(_objectSpread(_objectSpread(_objectSpread({}, LinkStyles.resetStyles), LinkStyles.variants.richText), LinkStyles.colors["default"]));
});
export default Content;